import React, { useRef, useState } from 'react';
import { BUTTON_TYPE } from '../../../constants/constant';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { t } from '../../../translation/translation';
import { Button } from '../../common/Button';
import './style.css'
import IMAGES_PATH from '../../../Images';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useNavigation } from '../../../hooks/useNavigate';

const VideoPlayer = () => {

    const {
        goToEURegulation,
        goToSupport,
        goToMission
    } = useNavigation()

    const isMobile = useIsMobile()
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setIsPlaying(true);
        }
    };

    return (
        <div className='video-player-container section'>
            <div className='video-player-content'>
                <video
                    ref={videoRef}
                    preload='metadata'
                    src=''
                    className="video-element"
                    controls
                />
                {!isPlaying && (
                    <div className='video-player-icon'>
                        <img
                            src={IMAGES_PATH.ICON_PLAYER}
                            alt="Play Button"
                            onClick={handlePlay}
                        />
                    </div>
                )}
            </div>
            <div className='video-player-button-container'>
                <Button
                    label={t(TEXT_KEYS.EU_REGULATIONS)}
                    type={BUTTON_TYPE.STROKE}
                    onClick={goToEURegulation}
                />
                {!isMobile ? (
                    <Button
                        label={t(TEXT_KEYS.SUPPORT_US)}
                        onClick={goToSupport}
                    />
                ) : null}
                <Button
                    label={t(TEXT_KEYS.OUR_MISSION)}
                    type={BUTTON_TYPE.STROKE}
                    onClick={goToMission}
                />
            </div>
            {isMobile ? (
                <div className='video-player-button-container-mobile'>
                    <Button
                        label={t(TEXT_KEYS.SUPPORT_US)}
                        onClick={goToSupport}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default VideoPlayer;